import axios from 'axios';
import { baseUrl, token } from '../../../services/Apis';

export const PROFESIONES_CONST = 'profesiones';

export const allProfesionesService = async (params) => {
  const res = await axios.get(`${baseUrl}/${PROFESIONES_CONST}`, {
    headers: token({}),
    params,
  });
  return res;
};

export const saveProfesionesService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${baseUrl}/${PROFESIONES_CONST}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(`${baseUrl}/${PROFESIONES_CONST}`, data, {
      headers: token({}),
    });
  }
  return res;
};

export const oneProfesionesService = async (id) => {
  const res = await axios.get(`${baseUrl}/${PROFESIONES_CONST}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const deleteProfesionesService = async (id) => {
  const res = await axios.delete(`${baseUrl}/${PROFESIONES_CONST}/${id}`, {
    headers: token({}),
  });
  return res;
};
